import d3 from 'd3';

/**
 * Create cluster icon as a donut chart, ported from map page
 *
 * @param options
 * @returns {string}
 */
function bakeThePie(options) {
  /* data and valueFunc are required */
  if (!options.data || !options.valueFunc) {
    return '';
  }

  options.strokeWidth = 1.5;

  const outerStrokeWidth = 2;

  const { data } = options;
  const { valueFunc } = options;
  const r = options.outerRadius ? options.outerRadius : 28; // Default outer radius = 28px
  const strokeWidth = options.strokeWidth ? options.strokeWidth : 1; // Default stroke is 1
  const pathClassFunc = options.pathClassFunc
    ? options.pathClassFunc
    : function () {
        return '';
      }; // Class for each path
  const pieClass = options.pieClass ? options.pieClass : 'marker-cluster-pie'; // Class for the whole pie
  const pieLabel = options.pieLabel ? options.pieLabel : d3.sum(data, valueFunc); // Label for the whole pie
  const pieLabelClass = options.pieLabelClass ? options.pieLabelClass : 'marker-cluster-pie-label'; // Class for the pie label
  const origo = r + strokeWidth + outerStrokeWidth; // Center coordinate
  const w = origo * 2; // width and height of the svg element
  const h = w;
  const donut = d3.layout.pie();
  const arc = d3.svg
    .arc()
    .innerRadius(r - 2)
    .outerRadius(r);

  // Create an svg element
  const svg = document.createElementNS('d3svg', 'svg');
  // Create the pie chart
  const vis = d3
    .select(svg)
    .data([data])
    .attr('class', pieClass)
    .attr('width', w)
    .attr('height', h);

  vis
    .append('circle')
    .attr('cx', origo)
    .attr('cy', origo)
    .attr('r', origo - 3)
    .attr('fill-opacity', '0.7')
    .attr('fill', '#000000');

  vis
    .append('circle')
    .attr('cx', origo)
    .attr('cy', origo)
    .attr('r', origo - 1)
    .attr('fill-opacity', '0.0')
    .attr('stroke', 'white')
    .attr('stroke-width', outerStrokeWidth);

  const arcs = vis
    .selectAll('g.arc')
    .data(donut.value(valueFunc))
    .enter()
    .append('svg:g')
    .attr('class', 'arc')
    .attr('transform', `translate(${origo},${origo})`);

  arcs
    .append('svg:path')
    .attr('class', pathClassFunc)
    .attr('stroke-width', strokeWidth + 1)
    .attr('d', arc)
    .append('svg:title');

  vis
    .append('text')
    .attr('x', origo)
    .attr('y', origo)
    .attr('class', pieLabelClass)
    .attr('text-anchor', 'middle')
    // .attr('dominant-baseline', 'central')
    // IE doesn't seem to support dominant-baseline, but setting dy to .3em does the trick
    .attr('dy', '.3em')
    .text(pieLabel);

  let html;

  // Return the svg-markup rather than the actual element
  if (typeof window.XMLSerializer !== 'undefined') {
    html = new window.XMLSerializer().serializeToString(svg);
  } else if (typeof svg.xml !== 'undefined') {
    html = svg.xml;
  } else {
    html = '';
  }

  return `<div class="marker-cluster" style="width: ${w - 5}px;height: ${h - 5}px">${html}</div>`;
}

export default function createClusterMarker(data) {
  const n = data.reduce((total, item) => total + item.value, 0);
  const rmax = 30; // Maximum radius for cluster pies
  const strokeWidth = 1; // Set clusterpie stroke width
  const r = rmax - 2 * strokeWidth - (n < 10 ? 12 : n < 100 ? 8 : n < 1000 ? 4 : 0); // Calculate clusterpie radius...

  return bakeThePie({
    data,
    valueFunc(d) {
      return d.value;
    },
    strokeWidth: 1,
    outerRadius: r,
    pieClass: 'cluster-pie',
    pieLabel: n,
    pieLabelClass: 'marker-cluster-pie-label',
    pathClassFunc(d) {
      return `category-${d.data.key}`;
    },
  });
}
